import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useState } from "react";

import { Select2ApplyBar, Select2MenuItem } from "~/components/select2";
import type { CurrencyOption } from "~/services/money";

export interface CurrencyFilterPopoverProps {
  currencies: CurrencyOption[];
  initialValue: string;
  onApply: (code: string) => void;
  onClose: () => void;
}

export function CurrencyFilterPopover({
  currencies,
  initialValue,
  onApply,
  onClose,
}: CurrencyFilterPopoverProps) {
  const [value, setValue] = useState(initialValue);
  const apply = () => {
    onApply(value);
    onClose();
  };
  const getFlagName = (code: string): string =>
    `${code.slice(0, 2).toLowerCase()}.svg`;

  return (
    <Stack>
      <Stack sx={{ maxHeight: 320, overflow: "auto" }}>
        {currencies.map((c: CurrencyOption) => (
          <Select2MenuItem
            key={c.code}
            label={
              <Stack
                direction="row"
                alignItems="center"
                spacing={1}
                component="span"
              >
                <img
                  src={`/country_flags/${getFlagName(c.code)}`}
                  alt=""
                  width={20}
                  height={14}
                />
                <Typography component="span" variant="body2">
                  {c.label}
                </Typography>
              </Stack>
            }
            selected={c.code === value}
            onClick={() => setValue(c.code === value ? "" : c.code)}
          />
        ))}
      </Stack>
      <Select2ApplyBar onApply={apply} />
    </Stack>
  );
}
